import { Flex, FlexProps } from '@chakra-ui/react';
import { sortDirections } from '~/clientApi/agencies.model';
import Spinner from '~/components/Spinner';
import { UpPointingTriangleIcon } from '~/components/icons';

interface SortIconProps extends FlexProps {
  sortDirection?: sortDirections;
  loading?: boolean;
}

export const SortIcon: React.FC<SortIconProps> = ({
  sortDirection,
  loading,
  ...props
}) => {
  return (
    <Flex direction="column" alignItems="center" {...props}>
      {loading ? (
        <Spinner
          centered={false}
          size="8px"
          color="primary.500"
          aria-label="Loading..."
          role="status"
        />
      ) : (
        <>
          <UpPointingTriangleIcon
            boxSize="6px"
            color={sortDirection === 'asc' ? 'primary.700' : 'primary.300'}
            data-testid={`sort-asc${sortDirection === 'asc' ? '--active' : ''}`}
          />
          <UpPointingTriangleIcon
            boxSize="6px"
            color={sortDirection === 'desc' ? 'primary.700' : 'primary.300'}
            transform="rotate(180deg)"
            marginTop="-1px"
            data-testid={`sort-desc${
              sortDirection === 'desc' ? '--active' : ''
            }`}
          />
        </>
      )}
    </Flex>
  );
};
